import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmNotNowClickedPayload {
  professionalId?: string;
  candidateId?: string;
  /** Total shift rows shown on the page when the user backed out. */
  shiftCount?: number;
}

/**
 * Fires when the user clicks "Not Now" on the bulk "Confirm Shifts" page.
 *
 * This dismissal is page-level and abandons every shift shown, so it carries
 * `shiftCount` (total shifts shown) rather than a single shift/offer — the
 * per-shift context lives on candidate_viewed. `candidate_count` is always 1
 * (GOTU-4815).
 *
 * Event: dental_portal:bulk_confirm:not_now_clicked
 */
export function fireBulkConfirmNotNowClicked(
  payload: IBulkConfirmNotNowClickedPayload = {},
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:not_now_clicked', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_count: payload.shiftCount,
    candidate_count: 1,
  });
}
